export enum AIProvider {
    GEMINI = 'Gemini',
    COPILOT = 'Copilot',
    OPENAI = 'ChatGPT',
    CLAUDE = 'Claude',
}
